module.exports = __webpack_public_path__ + "img/MitsubishiBig.ac3920ad.jpg";